import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenDa = () => {
    return <AddStartpageComToYourHomeScreen languageCode="da" />
}

export default AddStartpageComToYourHomeScreenDa
